
//轨迹漫游类
var matrix4 = new Cesium.Matrix4();
var matrix3Scratch = new Cesium.Matrix3();
var positionScratch = new Cesium.Cartesian3();
var orientationScratch = new Cesium.Quaternion();

class PathAnimation {

    constructor(options) {
        this.viewer = options.viewer || viewer;
        //参考系
        this._fixedFrameTransform = Cesium.defaultValue(options.fixedFrameTransform, Cesium.Transforms.eastNorthUpToFixedFrame);
        this.entity = options.entity; //漫游实体
        this.speed = options.speed || 30;// 漫游速度（km/h）30km/h
        this.multiple = options.multiple; //倍速
        this.positions = options.positions; //漫游路径
        this.speed_m = options.speed * 0.2777777777777778; //漫游速度-米每秒

        this.positionsArc = options.positions;
        //this.positionsArc = this.chack(options.positions); //处理一下
        //this.allTime = this.positionsArc.length; //总时间=点数*每秒（即每秒一个点位）
        this.addHeight = options.addHeight || 0;
        this.height = options.height || 0; //漫游高度
        this.shadingType = options.shadingType; //投影动画
        this.cameraType = options.cameraType; //飞行模式
        this.surface = options.surface; //飞行模式
        this.cycle = options.cycle; //是否循环
        if (!this.surface && this.height > 0 && this.addHeight <= 0) {
            this.positionsArc = this.setPositionsHeight(this.positionsArc, this.height);
        }
        if (!this.surface && this.addHeight > 0 && this.height <= 0) {
            this.positionsArc = this.addPositionsHeight(this.positionsArc, this.addHeight);
        }

        this.animationAllTime = options.sumTime;
        if (this.animationAllTime && this.animationAllTime > 0) {
            var l = this.getLength(this.positionsArc);
            this.speed_m = l / this.animationAllTime; //m/s
            this.speed_m = this.speed_m < 0.2 ? 0.2 : this.speed_m;

            console.log(this.animationAllTime);
            console.log(l);
            console.log(this.speed_m);
        }
        // if (!this.surface && this.height > 0 && this.addHeight > 0) {
        //     this.positionsArc = this.setPositionsHeight(this.positionsArc, this.height, true);
        // }
        // if (this.surface) {
        //     this.positionsArc = this.setPositionsHeight(this.positionsArc, 0, false);
        // }
        this.originPath = options.originPath; //原始数据
        this.passRoute = []; //已经飞过的路径
        this.passIndex = 0;//飞过的下标
    }

    /**
    * 在坐标基础海拔上增加指定的海拔高度值
    * @param {Array} positions Cartesian3类型的数组
    * @param {Number} height 高度值
    * @return {Array} Cartesian3类型的数组
    */
    addPositionsHeight(positions, addHeight) {
        addHeight = Number(addHeight) || 0;

        if (isNaN(addHeight) || addHeight == 0) return positions;

        if (positions instanceof Array) {
            var arr = [];
            for (var i = 0, len = positions.length; i < len; i++) {
                var car = Cesium.Cartographic.fromCartesian(positions[i]);
                var point = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, car.height + addHeight);
                arr.push(point);
            }
            return arr;
        } else {
            var car = Cesium.Cartographic.fromCartesian(positions);
            return Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, car.height + addHeight);
        }
    }

    setPositionsHeight(positions, height) {
        height = Number(height) || 0;

        if (positions instanceof Array) {
            var arr = [];
            for (var i = 0, len = positions.length; i < len; i++) {
                var car = Cesium.Cartographic.fromCartesian(positions[i]);
                var point = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
                arr.push(point);
            }
            return arr;
        } else {
            var car = Cesium.Cartographic.fromCartesian(positions);
            return Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
        }
    }

    /**
     * 设置坐标中海拔高度为指定的高度值
     * @param {Array} positions Cartesian3类型的数组
     * @param {Number} height 高度值
     * @return {Array} Cartesian3类型的数组
     */
    setPositionsHeightFixed(positions, height, isFixed) {
        height = Number(height) || 0;

        if (positions instanceof Array) {
            var arr = [];
            for (var i = 0, len = positions.length; i < len; i++) {
                var car = Cesium.Cartographic.fromCartesian(positions[i]);
                var heightTerrain = this.viewer.scene.globe.getHeight(car) + 0.2; //多加0.2M
                var sumHeight = isFixed ? height : heightTerrain + height;
                var point = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, sumHeight);
                arr.push(point);
            }
            return arr;
        } else {
            var car = Cesium.Cartographic.fromCartesian(positions);
            return Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, height);
        }
    }

    chack(positions) {
        if (positions.length == 2) {
            var mid = new Cesium.Cartesian3(0, 0, 0)
            Cesium.Cartesian3.midpoint(positions[0], positions[1], mid);
            positions.splice(1, 0, mid);
        }
        var res = this.removeDuplicate(positions);
        return res;
    }

    //去除相邻重复点
    removeDuplicate(positions) {
        if (positions.length < 2) {
            return positions;
        }
        let res = [];
        let j = 0;
        res.push(positions[0]);
        for (let i = 1; i < positions.length; i++) {
            if (res[j].x == positions[i].x && res[j].y == positions[i].y && res[j].z == positions[i].z) {
                continue;
            }
            j++;
            res.push(positions[i]);
        }
        return res;
    }

    getTime(dis, speed) {
        var time = dis / speed;
        return time < 0.01 ? 0.01 : time;
    }

    //获取当前时间走到的下标项目
    getItem() {

        // //第一个
        // if (this.passIndex < 1) {
        //     this.passIndex++; //走一个点
        //     return this.originPath[0];
        // }

        // //最后一个点
        // if (this.passIndex >= this.positions.length - 1) {
        //     this.passIndex = this.positions.length - 1
        //     return this.originPath[this.passIndex];
        // }

        // //走过的长度
        // let passL = this.getLength(this.passRoute);
        // //走过的距离
        // let currentL = this.getLength(this.positions.slice(0, this.passIndex));
        // if (currentL < passL) {
        //     this.passIndex++; //走一个点
        //     return this.getItem();
        // }

        // return this.originPath[this.passIndex];

        //第一个点
        if (!this.passRoute || this.passRoute.length < 1) {
            return this.originPath[0];
        }
        let L = this.passRoute.length;
        let p = this.passRoute[L - 1]; //当前位置
        this.passIndex = this.tryUpdateNearestIndex(this.originPath, p, this.passIndex);
        console.log("lastIndex", this.passIndex);
        return this.originPath[this.passIndex];
    }


    /**
     * 从当前索引开始，尝试更新最近点的索引（只能递增）
     * @param {Array} originPath - 路径点数组
     * @param {Cesium.Cartesian3} p - 当前位置
     * @param {number} currentIndex - 当前最近点的索引
     * @returns {number} - 新的最近点索引（可能与传入的相同）
     */
    tryUpdateNearestIndex(originPath, p, currentIndex) {
        // 确保不是最后一个点
        if (currentIndex >= originPath.length - 1) {
            return currentIndex; // 已经是最后一个点，无法更新
        }

        // 当前最近点的距离
        let currentPoint = Cesium.Cartesian3.fromDegrees(
            originPath[currentIndex].longitude,
            originPath[currentIndex].latitude,
            originPath[currentIndex].altitude
        );
        let currentDistance = Cesium.Cartesian3.distance(p, currentPoint);

        // 下一个点的距离
        let nextIndex = currentIndex + 1;
        let nextPoint = Cesium.Cartesian3.fromDegrees(
            originPath[nextIndex].longitude,
            originPath[nextIndex].latitude,
            originPath[nextIndex].altitude
        );
        let nextDistance = Cesium.Cartesian3.distance(p, nextPoint);

        // 如果下一个点更近，则更新索引
        if (nextDistance < currentDistance) {
            return nextIndex;
        }

        // 否则保持当前索引
        return currentIndex;
    }

    //计算总长(米)
    getLength(positions) {
        if (!Cesium.defined(positions) || positions.length < 2) return 0;

        var distance = 0;
        for (var i = 1, len = positions.length; i < len; i++) {
            distance += Cesium.Cartesian3.distance(positions[i - 1], positions[i]);
        }
        return distance;
    }

    getInterMeter() {
        var m_s = this.speed * 0.2777777777777778; //米每秒
        return this.allLen <= m_s ? this.allLen / 2 : m_s;
    }
    //插值线路
    interPolyline(opts) {
        var positions = opts.positions;
        var flatPositions = Cesium.PolylinePipeline.generateArc({
            positions: positions,
            height: opts.height, //未传入时，内部默认为0
            minDistance: opts.minDistance, //插值间隔(米)，优先级高于granularity
        });

        var arr = [];
        for (var i = 0; i < flatPositions.length; i += 3) {
            var position = Cesium.Cartesian3.unpack(flatPositions, i);
            arr.push(position);
        }
        return arr;
    }

    bezierSpline(positions) {

        let arr = [];
        for (let i = 0; i < positions.length; i++) {
            let pos = positions[i];
            var car = Cesium.Cartographic.fromCartesian(pos);
            arr.push([car.longitude, car.latitude])
        }

        // 定义一个包含原始折线坐标的GeoJSON对象
        const line = turf.lineString(arr);

        // 使用turf.js中的bezierSpline函数将折线平滑成贝塞尔曲线
        const bezierLine = turf.bezierSpline(line, {
            sharpness: 0.98
        });

        let coordinates = bezierLine.geometry.coordinates;
        let bezierArr = [];
        for (let j = 0; j < coordinates.length; j++) {
            var point = Cesium.Cartesian3.fromRadians(coordinates[j][0], coordinates[j][1], 50);
            bezierArr.push(point);
        }

        return bezierArr;
    }

    createBackPositionProperty() {
        var property = new Cesium.SampledPositionProperty(); //位置属性
        var startTime = viewer.clock.currentTime.clone(); //飞行开始时间
        var stopTime; //飞行结束时间 
        //let positions = item.line.formData.raisedPositions.reverse();
        var positionsArc = this.passRoute.reverse();
        var length = positionsArc.length;//100
        var sumTime = 0;
        for (var i = 0; i < length; i++) {
            var item = positionsArc[i];
            //起点
            if (i === 0) {
                property.addSample(startTime, item);
            }
            else {
                var pre = positionsArc[i - 1];
                var dis = this.getLength([pre, item]);
                var time = this.getTime(dis, this.speed_m);
                sumTime += time;
                var sTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
                property.addSample(sTime, item);
            }
        }

        stopTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
        property.setInterpolationOptions({
            interpolationDegree: 1,
            interpolationAlgorithm: Cesium.LinearApproximation// //Cesium.LagrangePolynomialApproximation //HermitePolynomialApproximation
        });
        property.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;

        this.startTime = startTime;
        this.stopTime = stopTime;
        return property;
    }

    //创建运动属性
    createPositionProperty() {


        var property = new Cesium.SampledPositionProperty(); //位置属性
        var startTime = viewer.clock.currentTime.clone(); //飞行开始时间
        var stopTime; //飞行结束时间 
        var positionsArc = this.positionsArc;
        //var positionsArc = this.bezierSpline(this.positionsArc);

        var length = positionsArc.length;//100
        var sumTime = 0;
        for (var i = 0; i < length; i++) {
            var item = positionsArc[i];
            //起点
            if (i === 0) {
                property.addSample(startTime, item);
            }
            else {
                var pre = positionsArc[i - 1];
                var dis = this.getLength([pre, item]);
                var time = this.getTime(dis, this.speed_m);
                sumTime += time;
                var sTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
                property.addSample(sTime, item);
            }
        }
        stopTime = Cesium.JulianDate.addSeconds(startTime, sumTime, new Cesium.JulianDate());
        property.setInterpolationOptions({
            interpolationDegree: 1,//
            interpolationAlgorithm: Cesium.HermitePolynomialApproximation// //Cesium.LagrangePolynomialApproximation //HermitePolynomialApproximation
        });
        if (!this.cycle) {
            property.forwardExtrapolationType = Cesium.ExtrapolationType.HOLD;
        }
        this.startTime = startTime;
        this.stopTime = stopTime;
        return property;
    }

    //求localStart点到localEnd点的方向
    getHeadingPitchRollForLine(localStart, localEnd, ellipsoid, fixedFrameTransform) {
        var cartesian3 = new Cesium.Cartesian3();
        var matrix4Scratch2 = new Cesium.Matrix4();
        var rotationScratch = new Cesium.Matrix3();

        ellipsoid = ellipsoid || Cesium.Ellipsoid.WGS84;
        var velocity = Cesium.Cartesian3.normalize(Cesium.Cartesian3.subtract(localEnd, localStart, cartesian3), cartesian3);
        Cesium.Transforms.rotationMatrixFromPositionVelocity(localStart, velocity, ellipsoid, rotationScratch);
        var modelMatrix = Cesium.Matrix4.fromRotationTranslation(rotationScratch, localStart, matrix4Scratch2);

        Cesium.Matrix4.multiplyTransformation(modelMatrix, Cesium.Axis.Z_UP_TO_X_UP, modelMatrix);

        var hpr = Cesium.Transforms.fixedFrameToHeadingPitchRoll(modelMatrix, ellipsoid, fixedFrameTransform);  // getHeadingPitchRollByMatrix(modelMatrix, ellipsoid, fixedFrameTransform);
        return hpr;
    }
    //获取点相对于中心点的地面角度
    getHeading(pointA, pointB) {

        //建立以点A为原点，X轴为east,Y轴为north,Z轴朝上的坐标系
        const transform = Cesium.Transforms.eastNorthUpToFixedFrame(pointA);
        //向量AB
        const positionvector = Cesium.Cartesian3.subtract(pointB, pointA, new Cesium.Cartesian3());
        //因transform是将A为原点的eastNorthUp坐标系中的点转换到世界坐标系的矩阵
        //AB为世界坐标中的向量
        //因此将AB向量转换为A原点坐标系中的向量，需乘以transform的逆矩阵。
        const vector = Cesium.Matrix4.multiplyByPointAsVector(Cesium.Matrix4.inverse(transform, new Cesium.Matrix4()), positionvector, new Cesium.Cartesian3());
        //归一化
        const direction = Cesium.Cartesian3.normalize(vector, new Cesium.Cartesian3());
        //heading
        const heading = Math.atan2(direction.y, direction.x) - Cesium.Math.PI_OVER_TWO;
        return Cesium.Math.TWO_PI - Cesium.Math.zeroToTwoPi(heading);
    }

    //开始漫游
    start() {
        if (this._isStart) {
            return;
        }

        //备份
        this._bak_multiplier = this.viewer.clock.multiplier;
        this._bak_clockRange = this.viewer.clock.clockRange;
        this._bak_startTime = this.viewer.clock.startTime;
        this._bak_stopTime = this.viewer.clock.stopTime;

        //this.setSurface(this.surface);

        var that = this;


        var positionProperty = this.createPositionProperty()
        //this.entity.orientation = new Cesium.VelocityOrientationProperty(positionProperty);
        // 创建一个自定义的方向属性
        // 存储上一次的航向，用于垂直起降时保持航向
        var prePosition;

        // 创建自定义的方向属性
        let VelocityOrientationProperty = new Cesium.VelocityOrientationProperty(positionProperty);
        // var customOrientationProperty = new Cesium.CallbackProperty(function (time, result) {

        //     let quaternion = VelocityOrientationProperty.getValue(time);
        //     if (quaternion) {
        //         // 先解出原始 HPR
        //         var hpr = Cesium.HeadingPitchRoll.fromQuaternion(quaternion);
        //         var heading = hpr.heading;
        //         var pitch = hpr.pitch;
        //         var roll = hpr.roll;

        //         console.log("pitch", Cesium.Math.toDegrees(pitch))

        //         // 若 pitch 超过 ±70°，重置 pitch 为 0
        //         if (Cesium.Math.toDegrees(pitch) > 70 || Cesium.Math.toDegrees(pitch) < -70) {
        //             pitch = 0;
        //         }

        //         // 需要 position 来重建 quaternion（必须是 ENU 本地坐标下）
        //         var position = positionProperty.getValue(time);
        //         if (!position) {
        //             return result;
        //         }
        //         let headingPitchRoll =new  Cesium.HeadingPitchRoll(heading, -70, roll)
        //         return Cesium.Quaternion.fromHeadingPitchRoll(headingPitchRoll);
        //     }
        //     return result;
        // }, false);
        this.entity.position = positionProperty;
        this.entity.orientation = VelocityOrientationProperty;


        // this.entity.path = {
        //     show: true,
        //     leadTime: 0,
        //     trailTime: 5,
        //     resolution: 1,
        //     material: new Cesium.PolylineGlowMaterialProperty({
        //         glowPower: 0.1,
        //         color: Cesium.Color.YELLOW
        //     }),
        //     width: 10
        // };

        // var orientation = new Cesium.VelocityOrientationProperty(this.entity.position);
        // this.entity.orientation = orientation;

        // var cylinder = this.createcylinder(positionProperty, this.height);

        // viewer.entities.add(cylinder);
        // this.cylinder = cylinder;



        viewer.clock.multiplier = this.multiple; //飞行速度 
        //viewer.clock.startTime = this.startTime.clone();
        // viewer.clock.currentTime = this.startTime.clone();
        // viewer.clock.stopTime = this.stopTime.clone();
        // viewer.clock.clockRange = Cesium.ClockRange.CLAMPED;
        // viewer.clock.onTick.addEventListener((clock) => {
        //     this.onTickCallback(clock);
        // });

        this.doShading(positionProperty);
        this.doCycle();
        this.viewer.scene.preRender.addEventListener(this.preRender_eventHandler, this);
        viewer.clock.shouldAnimate = true;
        this._isStart = true;
    }
    //暂停漫游
    pause() {
        this.viewer.clock.shouldAnimate = false;
    }
    //继续漫游
    proceed() {
        this.viewer.clock.shouldAnimate = true;
    }
    //结束漫游
    stop() {
        this.viewer.trackedEntity = undefined;
        this.viewer.scene.preRender.removeEventListener(this.preRender_eventHandler, this);
        if (this.entity) {
            this.viewer.entities.remove(this.entity);
            delete this.entity;
        }
        if (this.shading) {
            this.viewer.entities.remove(this.shading);
            delete this.shading;
        }

        if (this._bak_startTime) {
            this.viewer.clock.startTime = this._bak_startTime;
            delete this._bak_startTime;
        }
        if (this._bak_stopTime) {
            this.viewer.clock.stopTime = this._bak_stopTime;
            delete this._bak_stopTime;
        }
        if (this._bak_multiplier) {
            this.viewer.clock.multiplier = this._bak_multiplier;
            delete this._bak_multiplier;
        }
        if (this._bak_clockRange) {
            this.viewer.clock.clockRange = this._bak_clockRange;
            delete this._bak_clockRange;
        }
        this._isStart = false;
        this.passRoute = [];

    }
    preRender_eventHandler(e) {
        if (!this._isStart || !this.viewer.clock.shouldAnimate || this.entity == null) return;
        if (Cesium.JulianDate.greaterThanOrEquals(this.viewer.clock.currentTime, this.stopTime)) {
            this.viewer.trackedEntity = undefined;
            this.viewer.scene.preRender.removeEventListener(this.preRender_eventHandler, this);
            var result = this.entity.position.getValue(this.viewer.clock.currentTime);
            this.entity.position = result;
            this.endBack && this.endBack();//回调
            this._isStart = false;


            if (this.viewer.trackedEntity != undefined) {
                this.viewer.trackedEntity = undefined;
            }
            this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
            console.log("漫游结束");
            return;
        }
        this.doCameraType()

        if (this.entity.fltPath) {
            var p = this.entity.position.getValue(this.viewer.clock.currentTime);
            this.passRoute.push(p);
        }

    }
    onTickCallback(clock) {
        this.doCameraType()
    }
    //返航
    doBack() {
        if (!this.passRoute && this.passRoute.length <= 1) {
            return;
        }
        var positionProperty = this.createBackPositionProperty()
        this.entity.position = positionProperty;
        this.entity.orientation = new Cesium.VelocityOrientationProperty(positionProperty);
    }
    doCycle() {
        if (this.cycle) {
            viewer.clock.clockRange = Cesium.ClockRange.LOOP_STOP;
        }
    }
    setSurface(val) {
        // if (val) {
        //     this.entity.model.heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
        // }
        // else {
        //     if (this.addHeight > 0) {
        //         this.entity.model.heightReference = Cesium.HeightReference.RELATIVE_TO_GROUND;
        //     }
        //     if (this.height > 0) {
        //         this.entity.model.heightReference = Cesium.HeightReference.NONE;
        //     }
        // }
    }
    setMultiplier(val) {
        if (isNaN(val)) {
            return;
        }
        if (val > 0) {
            this.multiple = val;
        }
        this.viewer.clock.multiplier = this.multiple; //飞行速度
    }
    doShading(positionProperty) {
        switch (this.shadingType) {
            case "wall":
                //entity = this.addWallShading(item);
                break;
            case "cylinder":
                var cylinder = this.createcylinder(positionProperty);
                this.viewer.entities.add(cylinder);
                this.shading = cylinder;
                break;
            case "circle":
                //entity = this.addCircleShading(item);
                break;
            case "polyline":
            case "polyline-going":
                //entity = this.addPolylineShading(item);
                break;
            default:
                break;
        }
    }
    setCameraType(cameraType) {
        this.cameraType = cameraType;
    }
    //处理相机视角
    doCameraType() {
        switch (this.cameraType) {//视角处理
            default:
                //无 
                if (this.viewer.trackedEntity != undefined) {
                    this.viewer.trackedEntity = undefined;
                }
                this.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
                break;
            case "gs":
                //跟随视角
                if (this.viewer.trackedEntity != this.entity) {
                    this.viewer.trackedEntity = this.entity;
                }
                break;
            case "dy":
                //锁定第一视角
                this.adjust()
                break;
            case "sd":
                //锁定上帝视角
                if (this.viewer.trackedEntity != this.entity) this.viewer.trackedEntity = this.entity;

                var matrix = this.getModelMatrix();
                var transformZ = 500; //距离运动点的高度（上方）
                this.viewer.scene.camera.lookAtTransform(matrix, new Cesium.Cartesian3(-1, 0, transformZ));
                break;
        }
    }

    // 实时调整位置
    adjust() {

        if (viewer.clock.shouldAnimate === true) {

            // 获取偏向角
            // let ori = orientation.getValue(viewer.clock.currentTime);

            // // 获取位置
            let center = this.entity.position.getValue(viewer.clock.currentTime);

            // // 1、由四元数计算三维旋转矩阵
            // var mtx3 = Cesium.Matrix3.fromQuaternion(ori);

            // 2、计算四维转换矩阵：
            var mtx4 = this.getModelMatrix();// Cesium.Matrix4.fromRotationTranslation(mtx3, center);
            // 3、计算角度：
            var hpr = Cesium.Transforms.fixedFrameToHeadingPitchRoll(mtx4);

            // 获取角度（弧度）
            const headingTemp = hpr.heading;
            const pitchTemp = hpr.pitch;

            // 调整角度为第一人称，注意调整的角度
            const heading = Cesium.Math.toRadians(Cesium.Math.toDegrees(headingTemp) + 90);
            const pitch = Cesium.Math.toRadians(Cesium.Math.toDegrees(pitchTemp) - 12);

            // 视角高度，根据模型大小调整
            const range = 140.0;

            // 动态改变模型视角
            viewer.camera.lookAt(center, new Cesium.HeadingPitchRange(heading, pitch, range));
        }
    }
    getModelMatrix() {
        var entity = this.entity;
        var time = this.viewer.clock.currentTime;

        var position = Cesium.Property.getValueOrUndefined(entity.position, time, positionScratch);
        if (!Cesium.defined(position)) {
            return undefined;
        }
        var result;
        var orientation = Cesium.Property.getValueOrUndefined(entity.orientation, time, orientationScratch);
        if (!Cesium.defined(orientation)) {
            result = this._fixedFrameTransform(position, undefined, matrix4);
        } else {
            result = Cesium.Matrix4.fromRotationTranslation(Cesium.Matrix3.fromQuaternion(orientation, matrix3Scratch), position, matrix4);
        }
        return result;
    }
    /////
    createcylinder(property) {
        if (this.surface) {
            return;
        }
        var sumHeight = this.height + this.addHeight;
        if (sumHeight <= 0) {
            return;
        }

        var that = this;
        var heightReference = Cesium.HeightReference.CLAMP_TO_GROUND;
        // if (that.addHeight > 0 && that.height <= 0) {
        //     //position = that.calcGlobePoint(position);
        //     heightReference = Cesium.HeightReference.RELATIVE_TO_GROUND;
        // }

        var material = new Cesium.RadarRadiationWaveMaterialProperty(
            {
                color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                repeat: 15,
                offset: 0,
                thickness: 0.3,
                duration: 3000,
            });

        var bottomRadiusNow = 100;
        var lengthNow = 100;
        // 圆锥
        const entity = new Cesium.Entity({
            position: new Cesium.CallbackProperty(function (time) {
                var position = Cesium.Property.getValueOrUndefined(property, time, new Cesium.Cartesian3());
                var car = Cesium.Cartographic.fromCartesian(position);
                var heightTerrain = viewer.scene.globe.getHeight(car);
                var newPoint = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, (car.height) / 2);
                // if (that.addHeight > 0 && that.height <= 0) {
                //     newPoint = Cesium.Cartesian3.fromRadians(car.longitude, car.latitude, 0);
                // }
                lengthNow = car.height - heightTerrain;
                bottomRadiusNow = lengthNow * 0.3; //地面圆半径

                return newPoint;
            }, false),
            cylinder: {
                length: new Cesium.CallbackProperty(function (time) {
                    return lengthNow;
                }, false), //圆锥高度
                topRadius: 0.0, //顶部半径
                bottomRadius: new Cesium.CallbackProperty(function (time) {
                    return bottomRadiusNow;
                }, false), //底部半径
                heightReference: heightReference,
                material: material, //
            },
        });

        return entity;
    }
    calcGlobePoint(position) {
        var height = this.addHeight;
        var carto = Cesium.Cartographic.fromCartesian(position);
        var heightTerrain = this.viewer.scene.globe.getHeight(carto);
        var point = Cesium.Cartesian3.fromRadians(carto.longitude, carto.latitude, heightTerrain + height);
        return point;
    }
}

export default PathAnimation;